import { throwIf } from '../throwErrorF/throwIfF.mts';
export function assertDefined(value, debugCtx) {
    throwIf(() => value == null, debugCtx);
}
